module.exports = __webpack_public_path__ + "static/media/13 - Lo Tom.1e6bbab1.wav";